import type { ReactNode } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../../../../components/ui/dialog';

export function QueueDialogFrame(props: { open: boolean; onOpenChange: (open: boolean) => void; title: string; description?: ReactNode; children: ReactNode; testId: string }) {
  return <Dialog open={props.open} onOpenChange={props.onOpenChange}>
    <DialogContent data-testid={props.testId}>
      <DialogHeader><DialogTitle>{props.title}</DialogTitle>{props.description && <DialogDescription>{props.description}</DialogDescription>}</DialogHeader>
      {props.children}
    </DialogContent>
  </Dialog>;
}

